import { useContactStore } from '@/store/contact';
import useApplicationCart from './applicationCart/applicationCart';
import {resetAllStores} from '@/store/store-utils';
import { useRouter } from 'vue-router';
import { APPLICATION_PROCESS } from '@/router/route-name';
import useCountry from './countryDependable';
import { reactive, toRefs } from 'vue';
import { useCheckoutData } from '@/components/payment-view/data/checkout';
import api from '@/core/api';

const state = reactive({
    setupLoading: false,
    applicationError: [],
});

export function useSetUpPayment() {
    const { updateContactInformationIfEmpty} = useContactStore();
    const { submitApplication, paymentRef } = useApplicationCart();
    const router = useRouter();
    const country = useCountry();
    const { setupLoading, applicationError } = toRefs(state);
    const {setCheckout} = useCheckoutData();

    async function setup() {
        updateContactInformationIfEmpty();
        setupLoading.value = true;
        applicationError.value = [];
        const response = await submitApplication();
    
        if (!response.success) {
            if (response.data.length === 0) {
                resetAllStores();
                router.push({name: APPLICATION_PROCESS});
                setupLoading.value = false;
                return;
            }
    
            applicationError.value = response.data;
            return;
        }
    
        const data = await api.payment.checkoutAmount(country.displayCode.toLowerCase(), paymentRef.value);
    
        setCheckout(data);
        setupLoading.value = false;
    }
    

    return {
        setupLoading,
        applicationError,
        setup
    }
}
